import {Injectable} from '@angular/core';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import {pushOrCreteNewArray, stringIsSet} from "./global-variables.service";
import {htmlData} from "../../pages/management-elements/elements-page/elements-page.component";

@Injectable({
    providedIn: 'root'
})
export class IconService {

    constructor(private iconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer,) {
    }

    addSvgIcon(name: string | undefined, path: string | undefined): string | undefined {
        if (!stringIsSet(name) || !stringIsSet(path)) {
            return undefined
        } else {
            this.iconRegistry.addSvgIcon(
                name,
                this.domSanitizer.bypassSecurityTrustResourceUrl(path));
            return name
        }
    }

    addAllIconToHtmlData(htmlData: htmlData[]) {
        const allIcon: { path: string, name: string }[] = []
        htmlData.forEach(
            htmlData => {
                htmlData.forms.forEach((form, index) => {
                    if (form.icon != null) {
                        const name = 'icon_' + index;
                        if (name != null) {
                            const index = allIcon.findIndex((icon) => icon.path == form.icon?.svgIcon);
                            if (index >= 0) {
                                form.icon.svgIcon = allIcon[index].name;
                            } else {
                                const nameAddIcon = this.addSvgIcon(name, form.icon?.svgIcon);
                                if (stringIsSet(nameAddIcon)) {
                                    allIcon.push({path: form.icon.svgIcon!, name: name})
                                    form.icon.svgIcon = name;
                                }
                            }
                        }
                    }
                })
            }
        )
        return allIcon;
    }


    addAllIconFromArray(array: any[],
                        getSvgIcon: (item: any) => string | undefined = (item: any) => item.svgIcon,
                        setSvgIcon: (item: any, svgIcon: string) => void = (item: any, svgIcon: string) => item.svgIcon = svgIcon
    ) {
        const svgIcons = array
            .filter(item => getSvgIcon(item) != null)
        const allIcon: { path: string, name: string }[] = [];
        svgIcons.forEach((itemWidthSvgIcon, i) => {
            const svgIcon = getSvgIcon(itemWidthSvgIcon);
            const name = 'icon_' + i;
            const index = allIcon.findIndex((icon) => icon.path == svgIcon);
            if (index >= 0) {
                setSvgIcon(itemWidthSvgIcon, allIcon[index].name)
            } else {
                const nameAddIcon = this.addSvgIcon(name, svgIcon);
                if (stringIsSet(nameAddIcon)) {
                    allIcon.push({path: svgIcon!, name: name})
                    setSvgIcon(itemWidthSvgIcon, name);
                }
            }
        })
        return allIcon;
    }

}
